import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class DeleteDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      show: props.show === undefined ? false : props.show,
      yesDisabled: false
    }

    this.onHandleClickYes = this.onHandleClickYes.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( this.props.show !== nextProps.show ) {
      this.setState( {
        show: nextProps.show === undefined ? false : nextProps.show
      }, () => {
        if ( this.state.show ) {
          this.setState( {
            yesDisabled: false
          } );
        }
      } );
    }
  }

  /**
   * Disables the 'Yes' button to stop multiple clicks/requests for deletes.
   * 
   * @param {Event} event Click event for 'Yes'.
   */
  onHandleClickYes( event ) {
    this.setState( {
      yesDisabled: true
    }, () => {
      this.props.onDelete( event );
    } );
  }

  /**
   * Resets the state for this dialog.
   * 
   * @param {Event} event Closing of this dialog.
   */
  onHandleClose( event ) {
    this.setState( {
      yesDisabled: false
    }, () => {
      this.props.onClose( event );
    } );
  }

  onRenderCaption() {
    return this.props.caption;
  }

  onRenderBody() {
    return (
      <span className="asr-dialog-delete-message">
        {this.props.body}
      </span>
    );
  }

  onRenderFooter() {
    return (
      <span className="asr-group-dialog-footer">
        <button className="asr-dialog-cancel-button" onClick={this.onHandleClose}>No</button>
        <button className="asr-dialog-save-button" onClick={this.onHandleClickYes} disabled={this.state.yesDisabled}>{this.state.yesDisabled ? 'Please wait' : 'Yes'}</button>
      </span>
    );
  }

  render() {
    if ( this.props.show ) {
      return (
        <Dialog show={this.props.show} width={30} height={30} >
          <DialogHeader caption={this.onRenderCaption()} closeButton onClose={this.onHandleClose} />
          <DialogBody>
            {this.onRenderBody()}
          </DialogBody>
          <DialogFooter>
            {this.onRenderFooter()}
          </DialogFooter>
        </Dialog>
      );
    } else {
      return null;
    }
  }
}

export default DeleteDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/DeleteDialog.js